import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";

function MetricCard({ title, value, icon, color, subtitle, loading, path }) {
  const Wrapper = path ? Link : "div";

  const renderIcon = () => {
    if (!icon) return null;

    // Image icon (imported asset)
    if (typeof icon === "string" && (icon.endsWith(".png") || icon.endsWith(".svg") || icon.endsWith(".jpg"))) {
      return (
        <img
          src={icon}
          alt=""
          className="metric-card-icon-img"
        />
      );
    }

    // Font / FA / Nucleo icon
    return <i className={icon} />;
  };

  return (
    <Wrapper
      to={path}
      style={path ? { textDecoration: "none" } : undefined}
    >
      <Card
        className={`card-stats mb-4 mb-xl-0 ${path ? "cursor-pointer" : ""}`}
      >
        <CardBody>
          <Row>
            <div className="col">
              <CardTitle
                tag="h5"
                className="text-uppercase text-muted mb-0"
              >
                {title}
              </CardTitle>

              {loading ? (
                <div
                  style={{
                    height: "28px",
                    width: "80px",
                    backgroundColor: "#e9ecef",
                    borderRadius: "4px",
                    marginTop: "6px",
                  }}
                />
              ) : (
                <span className="h2 font-weight-bold mb-0">
                  {value}
                </span>
              )}

              {subtitle && (
                <p className="text-sm mt-2 mb-0 text-muted">
                  {subtitle}
                </p>
              )}
            </div>

            <Col className="col-auto">
              <div
                className={`icon icon-shape bg-gradient-${color} text-white rounded-circle shadow metric-card-icon`}
              >
                {renderIcon()}
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Wrapper>
  );
}

MetricCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  icon: PropTypes.oneOfType([PropTypes.string]).isRequired,
  color: PropTypes.string,
  subtitle: PropTypes.string,
  loading: PropTypes.bool,
  path: PropTypes.string,
};

MetricCard.defaultProps = {
  color: "primary",
  loading: false,
};

export default MetricCard;
